import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { TranslatePipe } from '@next/core-lib/i18n';
import { RouterSelectors } from '@next/core-lib/router-store';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap, take, withLatestFrom } from 'rxjs/operators';

import { getSelectedCalculationId } from '../../store/feed-profit.selectors';

@Component({
  selector: 'app-feed-profit-navigation',
  templateUrl: './feed-profit-navigation.component.html',
  imports: [MatTabNav, MatTabLink, MatTabNavPanel, AsyncPipe, TranslatePipe],
})
export class FeedProfitNavigationComponent {
  private readonly baseUrl = '/feed-profit';

  calculationId$: Observable<number> = this.store.select(getSelectedCalculationId);

  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getPath));

  isQuickSimulation$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('quick-simulation') > 0),
  );
  isExtendedSimulation$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('extended-simulation') > 0),
  );
  isIntro$: Observable<boolean> = this.isQuickSimulation$.pipe(
    withLatestFrom(this.isExtendedSimulation$),
    switchMap(([isQuickSimulation, isExtendedSimulation]) => [
      !(isQuickSimulation || isExtendedSimulation),
    ]),
  );

  constructor(
    private readonly store: Store<RootState>,
    private readonly router: Router,
  ) {}

  navigate(route?: string) {
    this.calculationId$.pipe(take(1)).subscribe((id) => {
      const url = route ? [this.baseUrl, id, route] : [this.baseUrl, id];

      this.router.navigate(url);
    });
  }
}
